import { render } from "./ChatMessageBubble.vue?vue&type=template&id=28fc1c01&scoped=true"
import script from "./ChatMessageBubble.vue?vue&type=script&lang=js"
export * from "./ChatMessageBubble.vue?vue&type=script&lang=js"

import "./ChatMessageBubble.vue?vue&type=style&index=0&id=28fc1c01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fc1c01"]])

export default __exports__